import {CONFIG} from '../../appConfig';
import STATE from '../../constants/state';

const CONTENT = 'content/';

export default {
  /**
   * @desc Partner reward programs surcharge endpoint
   * @param {Object} data {params}
   * @returns {Object}
   * @memberof services.gma.content
   * @example
   * services.gma.content.privacy();
   * // dispatched results stored in `state.gmi.gma.content.partner_reward_programs_surcharge`
   */
  partnerRewardProgramsSurcharge(data = {}) {
    const {params = {}} = data;
    return {
      method: 'GET',
      origin: CONFIG.GMA_ORIGIN_URL,
      endpoint: `${CONTENT}partnerRewardProgramsSurcharge`,
      params,
      statePath: STATE.GMA.CONTENT.PARTNER_REWARD_PROGRAMS_SURCHARGE,
      trimRespProp: 'partner_reward_programs_surcharge'
    };
  },

  /**
   * @desc Privacy policy endpoint
   * @param {Object} data {params}
   * @returns {Object}
   * @memberof services.gma.content
   * @example
   * services.gma.content.privacy();
   * // dispatched results stored in `state.gmi.gma.content.privacy`
   */
  privacy(data = {}) {
    const {params = {}} = data;
    return {
      method: 'GET',
      origin: CONFIG.GMA_ORIGIN_URL,
      endpoint: `${CONTENT}privacy`,
      params,
      statePath: STATE.GMA.CONTENT.PRIVACY
    };
  },

  /**
   * @desc Pass in country code and get contact information object for that country
   * @param {Object} data {endpoint, params}
   * @returns {Object}
   * @memberof services.gma.content
   * @example
   * const data = {
   *  endpoint: {
   *    country // *(String)* i.e. 'US'
   *  }
   * };
   * services.gma.content.supportContact(data);
   * // dispatched results stored in `state.gmi.gma.content.support.contact`
   */
  supportContact(data = {}){
    const {endpoint = {}, params = {}} = data;
    return {
      method: 'GET',
      origin: CONFIG.GMA_ORIGIN_URL,
      // NOTE: this endpoint is NOT in content and actually in reservations in GBO but we anticipate it moving here
      endpoint: `reservations/support/contact/${endpoint.country}`,
      params,
      statePath: STATE.GMA.CONTENT.SUPPORT.CONTACT.concat([endpoint.country])
    };
  },

  /**
   * @desc Taxes endpoint
   * @param {Object} data {params}
   * @returns {Object}
   * @memberof services.gma.content
   * @example
   * services.gma.content.taxes();
   * // dispatched results stored in `state.gmi.gma.content.taxes`
   */
  taxes(data = {}) {
    const {params = {}} = data;
    return {
      method: 'GET',
      origin: CONFIG.GMA_ORIGIN_URL,
      endpoint: `${CONTENT}taxes`,
      params,
      statePath: STATE.GMA.CONTENT.TAXES
    };
  },

  /**
   * @desc Loyalty terms and conditions endpoint
   * @param {Object} data {params}
   * @returns {Object}
   * @memberof services.gma.content
   * @example
   * services.gma.content.termsLoyalty();
   * // dispatched results stored in `state.gmi.gma.content.terms.loyalty`
   */
  termsLoyalty(data = {}) {
    const {params = {}} = data;
    return {
      method: 'GET',
      origin: CONFIG.GMA_ORIGIN_URL,
      endpoint: `${CONTENT}terms/loyalty`,
      params,
      statePath: STATE.GMA.CONTENT.TERMS.LOYALTY
    };
  },

  /**
   * @desc Country specific terms of use
   * @param {Object} data {endpoint, params}
   * @returns {Object}
   * @memberof services.gma.content
   * @example
   * const data = {country: 'US'};
   * services.gma.content.termsOfUse(data);
   * // dispatched results stored in `state.gmi.gma.content.termsOfUse[data.country]`
   */
  termsOfUse(data = {}) {
    const {endpoint = {}, params = {}} = data;
    return {
      method: 'GET',
      origin: CONFIG.GMA_ORIGIN_URL,
      endpoint: `${CONTENT}termsOfUse/${endpoint.country}`,
      params,
      statePath: STATE.GMA.CONTENT.TERMS_OF_USE.concat([endpoint.country])
    };
  },

  /**
   * @desc Prepay terms and conditions endpoint
   * @param {Object} data {params}
   * @returns {Object}
   * @memberof services.gma.content
   * @example
   * services.gma.content.termsPrepay();
   * // dispatched results stored in `state.gmi.gma.content.terms.prepay`
   */
  termsPrepay(data = {}) {
    const {params = {}} = data;
    return {
      method: 'GET',
      origin: CONFIG.GMA_ORIGIN_URL,
      endpoint: `${CONTENT}terms/prepay`,
      params,
      statePath: STATE.GMA.CONTENT.TERMS.PREPAY
    };
  }
};


